/* Fabric Alex PDP corrective layer v9 — compact mobile hero + reliable thumbnail rail. */
(function () {
  'use strict';

  var body = document.body;
  if (!body || !body.classList.contains('template-product')) return;
  if (!window.matchMedia('(max-width: 800px), (pointer: coarse)').matches) return;

  function setImportant(el, properties) {
    if (!el) return;
    Object.keys(properties).forEach(function (property) {
      el.style.setProperty(property, properties[property], 'important');
    });
  }

  function hideMobileSku(section) {
    if (!section) return;
    var meta = section.querySelector('.product-meta');
    if (!meta) return;

    /* Remove SKU copies created by earlier mobile PDP layers. */
    Array.prototype.forEach.call(meta.querySelectorAll('.fa-inline-sku, .fa-pdp-sku'), function (sku) {
      if (sku && sku.parentNode) sku.parentNode.removeChild(sku);
    });

    /* Keep SKU in Shopify/admin data, but never reserve storefront space for it on mobile. */
    Array.prototype.forEach.call(meta.querySelectorAll('.product-meta__sku'), function (sku) {
      setImportant(sku, {
        display: 'none',
        visibility: 'hidden',
        width: '0',
        height: '0',
        'min-width': '0',
        'min-height': '0',
        margin: '0',
        padding: '0',
        overflow: 'hidden'
      });
    });

    Array.prototype.forEach.call(meta.querySelectorAll('.product-meta__reference'), function (reference) {
      setImportant(reference, {
        position: 'static',
        display: 'none',
        visibility: 'hidden',
        width: '0',
        height: '0',
        'min-width': '0',
        'min-height': '0',
        margin: '0',
        padding: '0',
        overflow: 'hidden',
        border: '0'
      });
    });

    var reviews = meta.querySelector('.product-meta__reviews-badge');
    var row = meta.querySelector('.fa-pdp-meta-row');

    if (!row && reviews) {
      row = document.createElement('div');
      row.className = 'fa-pdp-meta-row';
      var title = meta.querySelector('.product-meta__title');
      if (title && title.nextSibling) title.parentNode.insertBefore(row, title.nextSibling);
      else if (title) title.parentNode.appendChild(row);
      else meta.insertBefore(row, meta.firstChild);
    }

    if (!row) return;

    if (reviews && reviews.parentNode !== row) row.appendChild(reviews);

    /* Strip any remaining SKU-like children without touching the reviews badge. */
    Array.prototype.forEach.call(row.querySelectorAll('.fa-inline-sku, .fa-pdp-sku, .product-meta__sku'), function (sku) {
      if (sku && sku.parentNode) sku.parentNode.removeChild(sku);
    });

    if (!reviews) {
      setImportant(row, {
        display: 'none',
        height: '0',
        'min-height': '0',
        margin: '0',
        padding: '0',
        overflow: 'hidden'
      });
      return;
    }

    row.hidden = false;
    setImportant(row, {
      position: 'static',
      display: 'flex',
      visibility: 'visible',
      width: '100%',
      height: 'auto',
      'min-height': '0',
      'max-height': 'none',
      'align-items': 'center',
      'justify-content': 'flex-start',
      'flex-wrap': 'nowrap',
      gap: '0',
      margin: '8px 0 0',
      padding: '0',
      overflow: 'visible',
      transform: 'none',
      clear: 'both'
    });

    setImportant(reviews, {
      position: 'static',
      top: 'auto',
      right: 'auto',
      bottom: 'auto',
      left: 'auto',
      display: 'inline-flex',
      visibility: 'visible',
      flex: '0 1 auto',
      width: 'auto',
      height: 'auto',
      'min-width': '0',
      'min-height': '0',
      'align-items': 'center',
      margin: '0',
      padding: '0',
      transform: 'none',
      float: 'none',
      border: '0',
      background: 'transparent',
      'box-shadow': 'none'
    });
  }

  function compactProductMeta(section) {
    if (!section) return;
    var meta = section.querySelector('.product-meta');
    if (!meta) return;

    /* The mobile hero should contain only the title and reviews. Do not let hidden desktop metadata reserve height. */
    setImportant(meta, {
      position: 'relative',
      display: 'flex',
      'flex-direction': 'column',
      'align-items': 'stretch',
      'justify-content': 'flex-start',
      width: '100%',
      height: 'auto',
      'min-height': '0',
      'max-height': 'none',
      margin: '0 0 -10px',
      padding: '15px 16px 9px',
      overflow: 'visible'
    });

    var title = meta.querySelector('.product-meta__title');
    if (title) {
      setImportant(title, {
        position: 'static',
        display: 'block',
        width: '100%',
        height: 'auto',
        'min-height': '0',
        'max-height': 'none',
        margin: '0',
        padding: '0',
        transform: 'none'
      });
    }

    var row = meta.querySelector('.fa-pdp-meta-row');
    if (row) {
      setImportant(row, {
        height: 'auto',
        'min-height': '0',
        'max-height': 'none',
        margin: '8px 0 0',
        padding: '0'
      });
    }

    /* Desktop-only share controls and any empty label shell must collapse completely on mobile. */
    Array.prototype.forEach.call(meta.querySelectorAll('.product-meta__share-buttons.hidden-phone'), function (share) {
      setImportant(share, {
        display: 'none',
        visibility: 'hidden',
        width: '0',
        height: '0',
        'min-height': '0',
        margin: '0',
        padding: '0',
        overflow: 'hidden'
      });
    });

    Array.prototype.forEach.call(meta.querySelectorAll('.product-meta__label-list'), function (labels) {
      if (!labels.textContent || !labels.textContent.trim()) {
        setImportant(labels, {
          display: 'none',
          height: '0',
          'min-height': '0',
          margin: '0',
          padding: '0',
          overflow: 'hidden'
        });
      }
    });

    /* Warehouse's separator sits between the meta and purchase form. It must not create a ghost gap here. */
    var sibling = meta.nextElementSibling;
    if (sibling && sibling.classList && sibling.classList.contains('card__separator')) {
      setImportant(sibling, {
        display: 'none',
        visibility: 'hidden',
        width: '0',
        height: '0',
        'min-height': '0',
        margin: '0',
        padding: '0',
        border: '0',
        overflow: 'hidden'
      });
    }
  }

  function selectedMediaId(section, list) {
    if (!section) return '';

    var selectedSlide = section.querySelector('.product-gallery__carousel-item.is-selected:not(.is-filtered)');

    if (selectedSlide) {
      return selectedSlide.getAttribute('data-media-id') || '';
    }

    if (list) {
      var selectedThumb = list.querySelector('.product-gallery__thumbnail.is-nav-selected:not(.is-filtered)');
      if (selectedThumb) return selectedThumb.getAttribute('data-media-id') || '';
    }

    return '';
  }

  function normalizeThumbnail(thumbnail, selected) {
    if (!thumbnail) return;

    if (thumbnail.classList.contains('is-filtered')) {
      setImportant(thumbnail, {
        display: 'none',
        visibility: 'hidden',
        opacity: '0',
        'box-shadow': 'none'
      });
      return;
    }

    setImportant(thumbnail, {
      position: 'relative',
      display: 'block',
      visibility: 'visible',
      opacity: '1',
      flex: '0 0 62px',
      width: '62px',
      'min-width': '62px',
      'max-width': '62px',
      height: '62px',
      'min-height': '62px',
      'max-height': '62px',
      margin: '0',
      padding: '0',
      overflow: 'hidden',
      transform: 'none',
      'box-sizing': 'border-box',
      border: selected ? '1px solid rgba(49,88,123,.78)' : '1px solid rgba(19,44,68,.20)',
      'border-radius': '11px',
      background: '#f3f0eb',
      'box-shadow': selected ? '0 0 0 2px #fff, 0 0 0 4px #0b3155' : 'none',
      'scroll-snap-align': 'none',
      'touch-action': 'manipulation'
    });

    var media = thumbnail.querySelector('.fa-product-gallery__thumbnail-media') ||
      thumbnail.querySelector('.aspect-ratio');

    if (!media) return;

    media.classList.remove('aspect-ratio');
    media.classList.remove('aspect-ratio--square');
    media.classList.add('fa-product-gallery__thumbnail-media');

    setImportant(media, {
      position: 'absolute',
      inset: '0',
      top: '0',
      right: '0',
      bottom: '0',
      left: '0',
      display: 'block',
      visibility: 'visible',
      opacity: '1',
      width: '100%',
      height: '100%',
      'min-width': '100%',
      'min-height': '100%',
      'max-width': '100%',
      'max-height': '100%',
      margin: '0',
      padding: '0',
      'padding-bottom': '0',
      overflow: 'hidden',
      transform: 'none',
      border: '0',
      background: 'transparent'
    });

    var image = media.querySelector('img');
    if (!image) return;

    image.classList.add('fa-product-gallery__thumbnail-image');

    setImportant(image, {
      position: 'absolute',
      inset: '0',
      top: '0',
      right: '0',
      bottom: '0',
      left: '0',
      display: 'block',
      visibility: 'visible',
      opacity: '1',
      width: '100%',
      height: '100%',
      'min-width': '100%',
      'min-height': '100%',
      'max-width': 'none',
      'max-height': 'none',
      margin: '0',
      padding: '0',
      transform: 'none',
      'transform-origin': 'center center',
      'object-fit': 'cover',
      'object-position': 'center center',
      border: '0',
      filter: 'none'
    });
  }

  function syncThumbnailSelection(section, list, preferredId) {
    if (!section || !list) return;

    var activeId = preferredId || selectedMediaId(section, list);
    var thumbnails = list.querySelectorAll('.product-gallery__thumbnail');
    var firstVisibleSelected = null;

    Array.prototype.forEach.call(thumbnails, function (thumbnail) {
      var id = thumbnail.getAttribute('data-media-id') || '';
      var selected = !!activeId && id === activeId && !thumbnail.classList.contains('is-filtered');

      if (selected) {
        if (!thumbnail.classList.contains('is-nav-selected')) thumbnail.classList.add('is-nav-selected');
        firstVisibleSelected = thumbnail;
      } else {
        if (thumbnail.classList.contains('is-nav-selected')) thumbnail.classList.remove('is-nav-selected');
      }

      normalizeThumbnail(thumbnail, selected);
    });

    if (!activeId && !firstVisibleSelected) {
      var fallback = list.querySelector('.product-gallery__thumbnail:not(.is-filtered)');
      if (fallback) {
        fallback.classList.add('is-nav-selected');
        normalizeThumbnail(fallback, true);
      }
    }
  }

  function fixThumbnailRail(section) {
    if (!section) return;
    var gallery = section.querySelector('.product-gallery');
    if (!gallery) return;

    var carouselWrapper = gallery.querySelector('.product-gallery__carousel-wrapper');
    var list = gallery.querySelector('.product-gallery__thumbnail-list');
    if (!list) return;

    var scroller = list.closest('.scroller');
    if (!scroller) return;

    scroller.classList.add('fa-pdp-thumbnail-scroller');

    if (carouselWrapper && scroller.previousElementSibling !== carouselWrapper) {
      if (carouselWrapper.nextSibling) gallery.insertBefore(scroller, carouselWrapper.nextSibling);
      else gallery.appendChild(scroller);
    }

    setImportant(scroller, {
      position: 'static',
      display: 'block',
      visibility: 'visible',
      opacity: '1',
      width: '100%',
      height: 'auto',
      'max-width': 'none',
      'max-height': 'none',
      margin: '9px 0 0',
      padding: '10px 0 3px',
      overflow: 'visible',
      transform: 'none',
      'border-top': '1px solid rgba(19,44,68,.10)',
      'touch-action': 'pan-x pan-y'
    });

    var inner = scroller.querySelector('.scroller__inner');
    if (inner) {
      setImportant(inner, {
        position: 'static',
        display: 'block',
        width: '100%',
        height: 'auto',
        margin: '0',
        padding: '0',
        overflow: 'visible',
        transform: 'none'
      });
    }

    setImportant(list, {
      position: 'static',
      display: 'flex',
      visibility: 'visible',
      opacity: '1',
      width: '100%',
      height: 'auto',
      'max-width': 'none',
      'max-height': 'none',
      'flex-wrap': 'nowrap',
      'align-items': 'center',
      gap: '8px',
      margin: '0',
      padding: '4px 18px 6px 4px',
      'overflow-x': 'auto',
      'overflow-y': 'hidden',
      transform: 'none',
      'scroll-snap-type': 'none',
      'scroll-behavior': 'auto',
      'overscroll-behavior-x': 'contain',
      'scrollbar-width': 'none',
      '-webkit-overflow-scrolling': 'touch',
      'touch-action': 'pan-x pan-y'
    });

    syncThumbnailSelection(section, list, '');
  }

  var repairQueued = false;

  function repairAll() {
    repairQueued = false;
    Array.prototype.forEach.call(document.querySelectorAll('[data-section-type="product"]'), function (section) {
      hideMobileSku(section);
      compactProductMeta(section);
      fixThumbnailRail(section);
      watchSection(section);
      bindThumbnailClicks(section);
    });
  }

  function queueRepair() {
    if (repairQueued) return;
    repairQueued = true;
    window.requestAnimationFrame(repairAll);
  }

  function bindThumbnailClicks(section) {
    if (!section || section.__faPdpV9ThumbClick) return;

    section.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var thumbnail = target.closest('.product-gallery__thumbnail');
      if (!thumbnail || !section.contains(thumbnail) || thumbnail.classList.contains('is-filtered')) return;

      var list = thumbnail.closest('.product-gallery__thumbnail-list');
      if (!list) return;

      var mediaId = thumbnail.getAttribute('data-media-id') || '';

      if (mediaId) syncThumbnailSelection(section, list, mediaId);

      window.setTimeout(queueRepair, 40);
      window.setTimeout(queueRepair, 140);
      window.setTimeout(queueRepair, 320);
    }, true);

    section.__faPdpV9ThumbClick = true;
  }

  function watchSection(section) {
    if (!section || section.__faPdpV9Observer) return;

    var observer = new MutationObserver(function (mutations) {
      var shouldRepair = false;

      for (var i = 0; i < mutations.length; i += 1) {
        var mutation = mutations[i];

        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          shouldRepair = true;
          break;
        }

        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          var target = mutation.target;
          if (
            target &&
            target.classList &&
            (
              target.classList.contains('product-gallery__thumbnail') ||
              target.classList.contains('product-gallery__carousel-item') ||
              target.classList.contains('product-meta__reference')
            )
          ) {
            shouldRepair = true;
            break;
          }
        }
      }

      if (shouldRepair) queueRepair();
    });

    observer.observe(section, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class']
    });

    section.__faPdpV9Observer = observer;
  }

  repairAll();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', repairAll);
  }

  document.addEventListener('variant:changed', function () {
    window.setTimeout(repairAll, 35);
    window.setTimeout(repairAll, 180);
  });

  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(repairAll, 0);
  });

  window.setTimeout(repairAll, 120);
  window.setTimeout(repairAll, 500);
  window.setTimeout(repairAll, 1200);
  window.setTimeout(repairAll, 2400);
})();